import React, {useState} from 'react';
import styled from 'styled-components';
import {IconoirCustomMoreVerticalAlt} from '@ey-xd/motif-icon';
import MotifDropdown from '@ey/motif-react-wrapper/Dropdown';
import MotifDropdownItem from '@ey/motif-react-wrapper/DropdownItem';
import MotifCheckbox from '../../../../../BaseComponentWrappers/MotifCheckbox';
import MotifButton from '@ey/motif-react-wrapper/Button';
import MotifIcon from '@ey/motif-react-wrapper/Icon';

export default function ALRAColumnChooser({columDefs, numberOfColsAllowedToSelect, label, gridRef}) {
	const [openColumnChooser, setOpenColumnChooser] = useState(false);

	const [columns, setColumns] = useState(columDefs);

	const handleClickOutside = () => {
		setOpenColumnChooser(false);
	};

	const toggleColumnChooser = () => {
		setOpenColumnChooser(!openColumnChooser);
	};

	const maxColumnsReached = () => {
		let selectedColums = columns.filter((column) => !column.baseColumn && !column.hide);
		if (selectedColums.length >= numberOfColsAllowedToSelect) {
			return true;
		}
		return false;
	};

	const handleOnChange = (field, checked) => {
		const index = columns.findIndex((column) => column.field === field);
		if (index > -1) {
			const newColumns = [...columns.slice(0, index), {...columns[index], hide: !checked}, ...columns.slice(index + 1)];
			setColumns(newColumns);

			if (gridRef?.current?.api) {
				gridRef.current.api.setColumnVisible(field, checked);
				gridRef.current.api.sizeColumnsToFit();
			}
		}
	};

	return (
		<StyledALRAColumnChooser className="StyledALRAColumnChooser">
			<MotifDropdown
				id="column-chooser"
				open={openColumnChooser}
				aria-labelledby="column-chooser-trigger"
				handleClickOutside={handleClickOutside}
				trigger={
					<MotifButton
						id="column-chooser-trigger"
						type="button"
						variant="ghost"
						onClick={toggleColumnChooser}
						aria-controls="column-chooser"
						aria-expanded={openColumnChooser}
						aria-label="dropdown triggerIdDropdownCustomizetable"
					>
						<MotifIcon src={IconoirCustomMoreVerticalAlt} />
					</MotifButton>
				}
			>
				<span className="ALRASelectUpToThreeOptions" title={label}>
					{label}
				</span>
				{columns &&
					columns.map((column) => {
						return (
							<DropdownItem
								key={column.field}
								column={column}
								onChange={handleOnChange}
								disabled={maxColumnsReached()}
							/>
						);
					})}
			</MotifDropdown>
		</StyledALRAColumnChooser>
	);
}

const StyledALRAColumnChooser = styled.section`
	display: flex;
	position: relative;
	width: var(--px-30);
	.motif-dropdown {
		width: var(--px-30);
		margin: 0 !important;
		.motif-dropdown-trigger {
			width: var(--px-30);
			svg {
				color: var(--neutrals-900);
				fill: none;
			}
		}
		.motif-dropdown-menu {
			position: relative;
			top: 0 !important;
			right: var(--px-270);
			padding: var(--px-16);
			border-radius: var(--px-4);
			width: var(--px-300);
			&[x-placement^='bottom-right']:before {
				right: var(--px-5);
			}
			.ALRASelectUpToThreeOptions {
				font-size: var(--px-16);
				font-weight: 400;
				line-height: var(--px-24);
				color: var(--neutrals-1000);
				margin-bottom: var(--px-10);
			}
			.motif-dropdown-item {
				padding: var(--px-8) 0;
				height: 100%;
				&:hover {
					background-color: transparent;
				}
				.ALRAChooserCheckboxContainer {
					width: 100%;
				}
				.motif-checkbox {
					width: auto;
					max-width: 100%;
					.motif-checkbox-label {
						width: 85% !important;
					}
				}
			}
		}
	}
`;

export function DropdownItem({column, disabled, onChange}) {
	let label = column.headerName;
	if (column.headerComponentParams && column.headerComponentParams.addDate) {
		label = `${column.headerName} ${column.headerComponentParams.date}`;
	}

	const handleOnChange = (field, checked) => {
		onChange(field, checked);
	};

	return (
		!column.baseColumn && (
			<MotifDropdownItem>
				{/* <MotifFormField> */}
				<MotifCheckbox
					styleName="ALRAChooserCheckboxContainer"
					className="ALRAChooserCheckbox"
					id={column.field}
					name={column.field}
					onChange={(event) => {
						handleOnChange(column.field, event.target.checked);
					}}
					value={column.field}
					checked={!column.hide}
					disabled={column.hide && disabled}
					ellipse
					label={label}
				>
					<span title={label}>{label}</span>
				</MotifCheckbox>
				{/* </MotifFormField> */}
			</MotifDropdownItem>
		)
	);
}
